<template>
	<div class="verify-email">
		<Card class="verify-email__card">
			<template #header>
				<div class="verify-email__logo-container">
					<img
						alt="codecannon logo"
						class="verify-email__logo"
						src="@/assets/logo.svg" /></div
			></template>
			<template #title>Verify Email</template>
			<template #content>
				<p>Please verify your email to continue</p>
				<Button
					label="Resend Email"
					:loading
					@click="resendEmail()" />
				<Divider />
				<Button
					label="Logout"
					outlined
					:disabled="loading"
					@click="router.push({ name: 'logout' })" />
			</template>
		</Card>
	</div>
</template>

<script setup lang="ts">
import AuthApi from '@/helpers/api/AuthApi'
import { ref } from 'vue'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Divider from 'primevue/divider'
import { useRouter } from 'vue-router'

const router = useRouter()
const loading = ref(false)

async function resendEmail() {
	loading.value = true
	try {
		await new AuthApi().resendEmailVerification()
	} finally {
		loading.value = false
	}
}
</script>

<style scoped lang="scss">
.verify-email {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	width: 100%;

	.verify-email__card {
		width: 500px;
		overflow: hidden;

		&:deep(.p-card-content) {
			display: flex;
			flex-direction: column;

			p {
				margin-bottom: 16px;
			}
		}
		.verify-email__logo {
			padding-left: 45px;
			padding-right: 45px;
			padding-bottom: 20px;
			padding-top: 20px;
			background: #eeff01;
			margin: auto;
			display: block;
		}
	}
}
</style>
